<template>
  <div class="text botter-conversation">
    <user-chat-image :sender="con.sender" v-if="con.sender.sender_type === 'BOT'"/>
    <div class="d-flex align-end" :class="getAlignment()">

      <div  class="botter-image" style="max-width: 300px !important">
        <img :src="con.mediaUrl || con.url" alt="">
      </div>
    </div>
    <div class="chat-date d-flex" :class="getAlignment()">{{$moment(con.created_at).add(parseInt($store.state.settings.settings.timeZoneShift), 'hours').format('MMMM Do YYYY')}} {{$moment(con.created_at).add(parseInt($store.state.settings.settings.timeZoneShift), 'hours').format('h:mm a')}}</div>
  </div>
</template>

<script>
  import userChatImage from "./common/userChatImage";
  import common from "../../../../utils/common";
  export default {
    name: "conversation",
    components: {
      userChatImage
    },
    props: {
      con: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      index: {
        type: Number,
        default: ()=> {
          return 0
        }
      }
    },
    data() {
      return {
        common
      }
    },
    methods: {
      getAlignment() {
        if (this.con.type==='user') {
          return 'justify-end'
        } else if(this.con.type==='bot') {
          return 'justify-start'
        }
      },
      getColor() {
        if (this.con.type==='user') {
          return 'botter-user-text'
        } else if(this.con.type==='bot') {
          return 'botter-bot-text'
        }
      }
    },
    computed: {
      lastMessageGroup() {
        return false
      }
    }
  }
</script>

<style lang="scss">
  .botter-image {
    margin-top: 10px;
    width: auto;
    display: inline-block;
    border-radius: 5px;
    img {
      border-radius: 10px;
    }
  }
</style>
